import { NgModule } from '@angular/core';
import { PanelModule } from 'primeng/panel';
import { SharedModule } from '../../../shared/shared.module';
import { OrganizationSearchComponent } from './organization-search.component';

@NgModule({
    declarations: [
        OrganizationSearchComponent
    ],
    providers: [],
    imports: [
        PanelModule,
        SharedModule
    ],
    exports: [
        OrganizationSearchComponent
    ]
})

export class OrganizationSearchModule {}
